// Checkout Forms
import { PHONE_NUMBER } from 'checkout-forms/form/fields';
import validate from 'checkout-forms/form/validation/validate';

// Config
import { internationalPhoneNumberLazy } from './lazyMainBundle';
import { getPhoneNumberDropdownOptions, phoneNumberRegex } from '@utils/address/addressHelpers';

export const DEFAULT_INTERNATIONAL_PHONE_OPTION = [
  {
    callingCode: '+44',
    label: 'United Kingdom (+44)',
    selectedLabel: '(+44)',
    placeholder: 'e.g. 000 000 0000',
    value: 'GB',
  },
];

export function validateSimplePhoneNumber(phoneNumber: string = '') {
  if (phoneNumber.length < 3) return undefined;

  const { parseInitialPhoneNumber } = internationalPhoneNumberLazy().component || {};
  const params = [phoneNumber, 'GB'];
  const phoneNumberCountryCode = parseInitialPhoneNumber?.(...params)?.countryCode;

  const result = validate(
    { phoneNumber, phoneNumberCountryCode },
    {
      config: {
        fields: [getInternationalPhoneNumberConfig()],
      },
    },
  );

  return result?.phoneNumber || undefined;
}

export default function getInternationalPhoneNumberConfig({
  instruction,
  isClickCollectOrder,
  isSimplePhoneNumberFeatureActive,
  showDefaultInstruction,
}: {
  instruction?: string;
  isClickCollectOrder?: boolean;
  isSimplePhoneNumberFeatureActive?: boolean;
  showDefaultInstruction?: boolean;
} = {}) {
  let fieldInstruction;

  if (instruction) {
    fieldInstruction = instruction;
  } else if (showDefaultInstruction) {
    if (isClickCollectOrder) {
      fieldInstruction = 'We’ll use this number to send text updates or if we have any queries with your order';
    } else {
      fieldInstruction = 'We’ll use this number if we have any queries with your payment';
    }
  }

  if (isSimplePhoneNumberFeatureActive) {
    return {
      ...PHONE_NUMBER,
      ...(fieldInstruction && { instruction: fieldInstruction }),
      regex: phoneNumberRegex,
      required: true,
      validationFnc: validateSimplePhoneNumber,
    };
  }

  const INTERNATIONAL_PHONE_NUMBER = internationalPhoneNumberLazy;
  const config = INTERNATIONAL_PHONE_NUMBER();
  const options = getPhoneNumberDropdownOptions();

  const PHONE_NUMBER_FIELD = config?.component
    ? {
        ...config,
        props: {
          options: options.length ? options : DEFAULT_INTERNATIONAL_PHONE_OPTION,
        },
        ...(fieldInstruction && { instruction: fieldInstruction }),
      }
    : config;

  return PHONE_NUMBER_FIELD;
}
